import { useState } from 'react';
import { ConversationList, ChatView, CustomerPanel } from '@/components/inbox';
import { mockConversations, mockMessages, mockCustomers } from '@/lib/mock-data';
import { cn } from '@/lib/utils';

export default function InboxPage() {
  const [selectedConversationId, setSelectedConversationId] = useState(null);
  const [conversations, setConversations] = useState(mockConversations);
  const [messages, setMessages] = useState(mockMessages);

  const selectedConversation = conversations.find((c) => c.id === selectedConversationId);
  const selectedCustomer = selectedConversation
    ? mockCustomers.find((c) => c.id === selectedConversation.customer.id)
    : null;

  const handleSendMessage = (content) => {
    if (!selectedConversationId) return;

    const newMessage = {
      id: `m_${Date.now()}`,
      content,
      sender: 'staff',
      timestamp: new Date().toISOString(),
    };

    setMessages((prev) => ({
      ...prev,
      [selectedConversationId]: [...(prev[selectedConversationId] || []), newMessage],
    }));

    // Update conversation last message
    setConversations((prev) =>
      prev.map((c) =>
        c.id === selectedConversationId
          ? { ...c, lastMessage: content, timestamp: new Date().toISOString() }
          : c
      )
    );
  };

  return (
    <div className="h-[calc(100vh-7rem)] -m-4 lg:-m-6 flex" data-testid="inbox-page">
      {/* Conversation List */}
      <div
        className={cn(
          'h-full md:w-80 md:shrink-0',
          selectedConversationId ? 'hidden md:block' : 'w-full'
        )}
      >
        <ConversationList
          conversations={conversations}
          selectedId={selectedConversationId}
          onSelect={setSelectedConversationId}
        />
      </div>

      {/* Chat View */}
      <div className={cn('flex-1', !selectedConversationId && 'hidden md:block')}>
        <ChatView
          conversation={selectedConversation}
          messages={messages[selectedConversationId] || []}
          onSendMessage={handleSendMessage}
          onBack={() => setSelectedConversationId(null)}
        />
      </div>

      {/* Customer Panel */}
      <div className="hidden lg:block">
        <CustomerPanel
          customer={selectedCustomer}
          conversation={selectedConversation}
        />
      </div>
    </div>
  );
}
